<template>
  <v-hover>
    <v-card
      style="
        position: fixed;
        top: 70px;
        right: 30px;
        z-index: 300;
        width: 300px;
        font-size: 13px;
        border: 1px solid #444;
      "
      color="#161d21"
      dark
    >
      <span>
        <v-row style="padding: 20px">
          <v-col v-if="computedItem.mtThumbsUrl || computedItem.clipThumbsUrl" cols="12">
            <div class="container-thumbnail">
              <v-img
                v-if="computedItem.clipType && computedItem.clipType === 'face'"
                contain
                class="thumbnail-img"
                :height="cardType !== 'grid' && isMobile ? 80 : 80"
                :src="computedItem.mtThumbsUrl || computedItem.clipThumbsUrl"
              />
              <v-img
                v-else
                cover
                class="thumbnail-img"
                :height="cardType !== 'grid' && isMobile ? 80 : 80"
                :src="computedItem.mtThumbsUrl || computedItem.clipThumbsUrl"
              />
            </div>
          </v-col>
          <v-col cols="12" style="padding: 10px 0 0 12px">
            <span class="">
              <v-avatar
                :color="
                  clipUploader.userPicture
                    ? ''
                    : clipUploader.userDisplayName || clipUploader.userFullName | iconBackground
                "
                class="logo mr-2"
                round
                size="18"
                style="display: inline-block; z-index: 6"
              >
                <div class="avatar-bg" v-if="clipUploader.userPicture"></div>
                <span class="v-avatar-name-playlist" v-if="!clipUploader.userPicture">
                  {{ clipUploader.userDisplayName || clipUploader.userFullName | iconFilter }}
                </span>
                <v-img :src="clipUploader.userPicture" v-else />
              </v-avatar>
            </span>
            <span>
              {{ clipUploader.userDisplayName || clipUploader.userFullName }}
            </span>
          </v-col>
          <v-col cols="12" v-if="clipUploader.userId !== userInfo.userId" style="padding: 15px 0 0 12px">
            <span v-if="computedItem.isWatched" style="color: #ddd">{{ 'This is the clip I watched' }}</span>
            <span v-else v-html="notWatched" style="color: #eee"></span>
          </v-col>
          <v-col
            cols="12"
            v-if="computedItem.watchedUser.length > 0"
            :style="clipUploader.userId !== userInfo.userId ? 'padding: 10px 0 0 12px' : 'padding: 15px 0 0 12px'"
          >
            <span style="color: #ddd">
              {{ computedItem.watchedUser.length }}
            </span>
            <span style="color: #ddd">
              {{ computedItem.watchedUser.length == 1 ? 'person watched' : 'people watched' }}
            </span>
          </v-col>
          <v-col cols="12" style="padding: 10px 0 10px 12px; color: #aaa">
            <span>Created</span>
            <span class="ml-1">
              {{ calCreateAt(computedItem.clipUploadedAt) }}
            </span>
          </v-col>
        </v-row>
      </span>
    </v-card>
  </v-hover>
</template>

<script>
// import Attendee from '@/views/meeting/component/card/Attendee'
import { setDurationToTime } from '@/common/lib/strLib'
import audioBg from '@/assets/img/audio-bg-fill.png'
import embedBg from '@/assets/img/embed-bg-fill.png'
import emptyThumbnail from '@/assets/img/empty-thumbnail2.png'
import Toast from '@/views/meeting/component/Toast'
// import store from '@/store'
import { isMobile } from '@/common/lib/strLib'
import { mapState } from 'vuex'
import { chkUploadedFile } from '@/services/api'

export default {
  name: 'PlayListDetail',
  // components: { Attendee },
  props: {
    cardType: String,
    clipIndex: Number,
    cardItem: Object,
    sectionIndex: Number,
  },
  data() {
    return {
      isLogoVisible: false,
      emptyThumbnail: emptyThumbnail,
      audioBg: audioBg,
      embedBg: embedBg,
      wsLogo: '',
      duration: 0,
      isThumbnailLoading: true,
      interval: null,
      notWatched: 'This is a clip I haven&#39;t seen yet',
    }
  },
  created() {
    this.callChkThumbnail()
  },
  methods: {
    callChkThumbnail() {
      let retryCount = 0
      if (
        this.cardType === 'list' &&
        (this.computedItem.clipType === 'screen' ||
          this.computedItem.clipType === 'face' ||
          this.computedItem.clipType === 'upload') &&
        (this.computedItem.clipThumbsUrl === undefined || this.computedItem.clipThumbsUrl === '')
      ) {
        this.interval = setInterval(() => {
          if (
            (this.computedItem.clipThumbsUrl !== undefined &&
              this.computedItem.clipThumbsUrl !== '' &&
              this.interval !== null) ||
            retryCount >= 5 ||
            !this.userInfo ||
            !this.userInfo.userId
          ) {
            clearInterval(this.interval)
            this.interval = null
            this.isThumbnailLoading = false
          } else {
            retryCount++
            this.chkUploadedFile()
          }
        }, 3000)
      } else {
        this.isThumbnailLoading = false
      }
    },
    async chkUploadedFile() {
      let result
      try {
        let path = 'https://file.tape.ooo/'
        let key = `clip/${this.mtInfo.wsId}/${this.computedItem.clipId}.webp`
        result = await chkUploadedFile(this, key)
        if (result) {
          this.computedItem.clipThumbsUrl = path + key
          this.isThumbnailLoading = false
        }
      } catch (e) {
        console.log()
      }
    },
    async detail(type) {
      if (this.computedItem.clipDuration === 0) {
        // notify(this, 'Error', 'Deleted Clip', 'error')

        const content = {
          component: Toast,
          props: {
            msg: 'Deleted Clip',
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } else if (this.cardType === 'grid') {
        this.$store.dispatch('setFirebaseLog', {
          eventName: 'view_meeting_detail',
          eventParam: {
            name: 'view_meeting_detail',
          },
        })
        // if (this.computedItem.mtIsUpdate) {
        //   if (this.$route.params.type === 'private') {
        //     let cnt = store.getters.privateCnt
        //     await store.dispatch('setPrivateCnt', cnt > 0 ? cnt - 1 : 0)
        //   } else if (this.$route.params.type === 'workspace') {
        //     let cnt = store.getters.workspaceCnt
        //     await store.dispatch('setWorkspaceCnt', cnt > 0 ? cnt - 1 : 0)
        //   }
        // }
        if (type === 'blank') {
          window.open(
            'about:blank'
          ).location.href = `/${this.wsInfo.wsDomain}/meeting/${this.$route.params.type}/${this.computedItem.mtId}`
        } else {
          this.$router
            .push(`/${this.wsInfo.wsDomain}/meeting/${this.$route.params.type}/${this.computedItem.mtId}`)
            .catch(() => {})
        }
      } else {
        if (!this.isPauseIcon) {
          this.$store.dispatch('setIsPauseSeek', true)
        }
        this.$emit('selectClip', this.computedItem, this.clipIndex)
        this.$store.dispatch('setIsFeedback', false)
      }
      // this.$router.push({ name: 'MeetingDetail', params: { meetingId: meetingId } })
    },
    calCreateAt(val) {
      return this.$day.duration(this.$day().diff(val)).humanize() + ' ago '
    },
    calDuration(val) {
      return setDurationToTime(val)
    },
  },
  computed: {
    isPauseIcon() {
      return this.$store.getters.isPauseIcon !== undefined && this.$store.getters.isPauseIcon !== null
        ? this.$store.getters.isPauseIcon
        : false
    },
    isPlay() {
      if (this.totalSectionList.length > 0)
        return (
          this.totalSectionList[this.sectionIndex].clipList[this.clipIndex].clipId === this.currentClip.clipId &&
          !this.isLastClip
        )
      else return false
    },
    isLastClip() {
      return this.$store.getters.isLastClip
    },
    computedItem() {
      return this.cardItem !== undefined && this.cardItem !== null ? this.cardItem : {}
    },
    clipUploader() {
      return this.computedItem && this.computedItem.clipUploader ? this.computedItem.clipUploader : {}
    },
    thumbnailText() {
      let textClip
      if (this.computedItem && this.computedItem !== null) textClip = this.computedItem.textClip
      if (textClip && textClip !== null && textClip.length > 70) textClip = `${textClip.substring(0, 70)} ...`
      return textClip
    },
    isMobile() {
      return isMobile()
      // return true
    },
    ...mapState({
      totalSectionList: (state) => {
        return state.clip.totalSectionList !== undefined && state.clip.totalSectionList !== null
          ? state.clip.totalSectionList
          : []
      },
      storeSectionIndex: (state) => {
        return state.clip.sectionIndex
      },
      storeClipIndex: (state) => {
        return state.clip.clipIndex
      },
      currentClip: (state) => {
        return state.clip.currentClip && state.clip.currentClip !== null ? state.clip.currentClip : {}
      },
      mtInfo: (state) => {
        return state.auth.currentMt
      },
      userInfo: (state) => {
        return state.auth.userInfo && state.auth.userInfo !== null ? state.auth.userInfo : {}
      },
      wsInfo: (state) => {
        return state.auth.selectedWsInfo
      },
    }),
    clipTitle() {
      return this.cardType !== 'grid' && this.totalSectionList.length > 0
        ? this.totalSectionList[this.sectionIndex].clipList[this.clipIndex].clipTitle
        : ''
    },
    clipNote() {
      return this.cardType !== 'grid' && this.totalSectionList.length > 0
        ? this.totalSectionList[this.sectionIndex].clipList[this.clipIndex].clipNote
        : ''
    },
  },
  watch: {
    clipTitle: {
      immediate: true,
      deep: true,
      handler(val) {
        this.cardItem.clipTitle = val
      },
    },
    clipNote: {
      immediate: true,
      deep: true,
      handler(val) {
        this.cardItem.clipNote = val
      },
    },
    computedItem: {
      deep: true,
      handler() {
        this.callChkThumbnail()
      },
    },
  },
}
</script>

<style scoped>
.isPlaying {
  /* outline: solid 3px #ff474f !important; */
  /* box-shadow: 0 0 0 3px #ff474f !important; */
  padding: 5px 8px;
  background-color: #30444e;
}
.container-card {
  /* outline: solid 3px transparent !important; */
  /* box-shadow: 0 0 0 3px transparent !important; */
  /* box-shadow: 0.5px 0.5px 0px 0px rgba(33, 33, 33, 0.3) !important; */
  padding: 5px 8px;
  background-color: #1d292f;
}
.v-card--flat:hover {
  /* box-shadow: 1px 1px 2px 0 #111 !important; */
  transform: translate(-1px, -1px);
}
.v-card--flat.isPlaying:hover {
  transform: translate(0px, 0px);
}

.card-sub-title {
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 5px;
  padding: 3px 5px;
  color: rgba(150, 167, 175, 0.7);
  font-size: 11px;
}
.crown {
  color: #ffc542;
  font-size: 15px;
  position: absolute;
  transform: translateY(-9px);
  margin-left: -24px;
  /* transform: translate(-24px, -9px); */
}

.avatar-bg {
  content: '';
  position: absolute;
  border-radius: 50%;
  top: 0px;
  left: 0px;
  width: calc(100%) !important;
  height: calc(100%) !important;
  background-color: white;
  z-index: 0;
}

.target {
  white-space: normal;
  line-height: 1.2;
  height: 40px;
  text-align: left;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.tag-container {
  position: relative;
  width: 100%;
  height: 34px;
  display: inline-block;
  word-break: normal;
  overflow: hidden;
  padding: 0px;
  flex-wrap: nowrap;
  margin-top: 8px;
  text-overflow: ellipsis;
}

span.card-tag {
  height: 20px;
  font-size: 12px;
  font-weight: 500;
  color: #bbb;
  padding: 8px;
  margin-right: 4px;
  margin-bottom: 16px;
  line-height: 15px;
  text-overflow: ellipsis;
  border-radius: 5px;
  word-break: normal;
  overflow: hidden;
  border: 1px solid #222;
  letter-spacing: -0.1px;
}

div.deleted-card {
  padding-top: 0px;
  padding-bottom: 2px;
  text-align: center;
  height: 30px;
  display: table;
}
span.deleted-card {
  width: 250px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  align-items: center;
  color: #96a7af;
  display: table-cell;
  vertical-align: middle;
}

.unread {
  width: 22px;
  height: 22px;
  padding: 2px 2px;
  background-color: #ff575f;
  color: white;
  text-align: center;
  align-self: center;
  font-size: 12px;
  cursor: pointer;
  border-radius: 8px;
  position: absolute;
  top: 22px;
  right: 2px;
  transform: translate(-50%, -50%);
}

.unread_clip {
  display: inline-block;
  position: absolute;
  top: 5px;
  left: 5px;
  width: 8px;
  height: 8px;
  background-color: #ff575f;
  align-self: center;
  border-radius: 5px;
  vertical-align: middle;
  z-index: 7;
  outline: 2px solid #1a272e;
}

.text-clip-thumbnail {
  width: 100%;
  height: 80px;
  background: #30444e;
  text-align: center;
  display: table;
}

.text-clip-thumbnail-mobile {
  width: 100%;
  height: 80px;
  background: #30444e;
  text-align: center;
  display: table;
}
.thumbnail-mobile-logo {
  display: none;
}

.text-clip-thumbnail-label {
  width: 100%;
  color: white;
  max-width: 200px;
  font-size: 13px;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  max-height: 70px;
  overflow: auto;
}
.v-avatar-name-playlist {
  color: #ffffff;
  font-size: 14px;
  text-align: center;
}
.v-card {
  transition: all 0.2s ease-in-out;
}
.label-ended {
  display: inline-block;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  background-color: #1a272e;
  color: #ccc;
  padding: 1px 3.5px 1px 5px;
  border-radius: 5px;
}
.container-uploading {
  width: 100%;
  height: 80px;
}
.txt-uploading {
  text-align: center;
  color: white;
}
.card-detail-title {
  font-weight: 400;
  font-size: 13px;
  color: rgba(238, 239, 252, 0.8);
  letter-spacing: -0.1px;
}
.isPlaying >>> .card-detail-title {
  color: rgba(238, 239, 252, 1);
}
.container-clip-desc {
  bottom: 0;
}
.container-thumbnail >>> .thumbnail-img {
  border-radius: 10px;
  background-color: #30444e;
}
.thumbnail-img {
  width: 260px;
  height: 146px !important;
}
</style>
